export default __webpack_public_path__ + "static/media/icon-preview.11a1dcf6.svg";